import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import logo3 from '../assets/logo3.png';
import './CSS/ImageConverter.css';

const ImageConverter = (props) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [userMessage, setUserMessage] = useState("");
  const [qrCodeUrl1, setQrCodeUrl1] = useState("");
  const [qrCodeUrl2, setQrCodeUrl2] = useState(null);  // Changed to null initially
  const [customUrl2, setCustomUrl2] = useState("");
  const [email, setEmail] = useState("");
  const [balance, setBalance] = useState(0);
  const messageRef = useRef(null);
  const COST_PER_DOWNLOAD = 100;

  useEffect(() => {
    const state = props.location && props.location.state;
    if (state && state.email && state.balance !== undefined) {
      setEmail(state.email);
      setBalance(state.balance);
    } else {
      fetchUserData();
    }
    generateQRCodes();  // Generate QR codes when component loads or customUrl2 changes
  }, [customUrl2]);

  const fetchUserData = async () => {
    try {
      const response = await fetch('/user-details', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        setEmail(data.email);
        setBalance(data.balance);
      } else {
        console.error('Failed to fetch user details');
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const generateQRCodes = async () => {
    try {
      const url1 = "https://www.docontheblock.io/searchengine";
      const qr1 = await QRCode.toDataURL(url1);
      setQrCodeUrl1(qr1);

      if (customUrl2) {
        const qr2 = await QRCode.toDataURL(customUrl2);
        setQrCodeUrl2(qr2);
      } else {
        setQrCodeUrl2(null);  // Clear second QR code if no custom URL
      }
    } catch (error) {
      console.error("Error generating QR Codes:", error);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid PNG or JPEG image");
    }
  };

  const handleUserImageUpload = (event) => {
    const file = event.target.files[0];
    if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
      const reader = new FileReader();
      reader.onloadend = () => setUploadedImage(reader.result);
      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid PNG or JPEG image");
    }
  };

  const addSilverWatermark = (pdf) => {
    const text = "New Wave & Siam U";
    const fontSize = 40;
    const silverColor = "#C0C0C0";
    pdf.setFontSize(fontSize);
    const textAngle = -45;
    const xOffset = 50;
    const yOffset = 100;

    for (let y = 10; y < 300; y += yOffset) {
      for (let x = 10; x < 200; x += xOffset) {
        pdf.setTextColor(silverColor);
        pdf.text(text, x, y, { angle: textAngle });
      }
    }
  };

  const handleDownloadImagePDF = async () => {
    if (!window.confirm("Are you sure you want to download and deduct 100 credits?")) return;

    if (balance < COST_PER_DOWNLOAD) {
      alert("You don’t have enough balance to generate the PDF!");
      return;
    }

    try {
      const newBalance = balance - COST_PER_DOWNLOAD;
      const response = await fetch('/update-balance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newBalance }),
      });

      if (!response.ok) {
        throw new Error("Failed to update balance.");
      }

      setBalance(newBalance);

      if (imagePreview && uploadedImage) {
        html2canvas(messageRef.current).then((canvas) => {
          const pdf = new jsPDF();
          const imgWidth = 130;
          const image = new Image();
          image.src = imagePreview;

          image.onload = () => {
            const aspectRatio = image.width / image.height;
            const imgHeight = imgWidth / aspectRatio;

            addSilverWatermark(pdf);

            const logoTop = new Image();
            logoTop.src = logo3;
            pdf.addImage(logoTop, "PNG", 80, 5, 50, 23);
            pdf.addImage(imagePreview, "JPEG", 10, 30, imgWidth, imgHeight);

            const messageImage = canvas.toDataURL("image/png");
            pdf.addImage(messageImage, "PNG", 10, imgHeight + 40, 180, 30);

            const pageHeight = pdf.internal.pageSize.height;
            const pageWidth = pdf.internal.pageSize.width;

            if (qrCodeUrl1) {
              const leftX = 10;
              pdf.setFontSize(12);
              pdf.setTextColor(0, 0, 0);
              pdf.addImage(qrCodeUrl1, "PNG", leftX, pageHeight - 130, 50, 50);
              pdf.text("Search on the Block", leftX, pageHeight - 75);

              if (qrCodeUrl2) {
                pdf.addImage(qrCodeUrl2, "PNG", leftX, pageHeight - 70, 50, 50);
                pdf.text("Certificate's Picture", leftX, pageHeight - 15);
              }
            }

            const verificationImage = new Image();
            verificationImage.src = uploadedImage;

            verificationImage.onload = () => {
              const verificationAspectRatio = verificationImage.width / verificationImage.height;
              const baseWidth = 50;
              const verificationImgWidth = baseWidth * 1.75;
              const verificationImgHeight = verificationImgWidth / verificationAspectRatio;

              pdf.addImage(
                uploadedImage,
                "JPEG",
                pageWidth - verificationImgWidth - 10,
                pageHeight - verificationImgHeight - 20,
                verificationImgWidth,
                verificationImgHeight
              );

              const logoBottom = new Image();
              logoBottom.src = logo2;
              pdf.addImage(logoBottom, "PNG", 90, pageHeight - 21, 30, 18);

              pdf.save("image_with_stacked_left_qrcodes.pdf");
            };
          };
        });
      }
    } catch (error) {
      console.error("Error deducting balance or generating PDF:", error);
      alert("An error occurred while generating the PDF or updating balance.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <img className="logo" src={logo} alt="Logo" />
      <div style={{ marginTop: "10px", fontWeight: "bold" }}>
        Email: {email || "Loading..."} | Balance: ${balance.toFixed(2)}
      </div>

      <h2>Step 1: Upload Your Document Image (jpg, png)</h2>
      <input type="file" accept="image/png, image/jpeg" onChange={handleImageUpload} />

      <h2>Step 2: Upload Your Digital Signature Image</h2>
      <input type="file" accept="image/png, image/jpeg" onChange={handleUserImageUpload} />

      <h2>Step 3: Enter Your Custom Certificate URL</h2>
      <input
        type="text"
        value={customUrl2}
        onChange={(e) => setCustomUrl2(e.target.value)}
        placeholder="Enter custom URL here (optional)"
        style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
      />

      <div style={{ marginTop: "20px" }}>
        <h4>Write a Message to Include in the Image PDF:</h4>
        <div ref={messageRef} style={{ padding: "10px", background: "#f8f8f8", fontSize: "16px", textAlign: "center" }}>
          {userMessage}
        </div>
        <textarea
          rows="4"
          cols="70"
          placeholder="Enter your message here"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          style={{ marginTop: "10px" }}
        />
      </div>

      <div style={{ marginTop: "40px", textAlign: "center" }}>
        {(qrCodeUrl1 || qrCodeUrl2) && (
          <>
            <h4>QR Codes</h4>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px' }}>
              {qrCodeUrl1 && (
                <div>
                  <img src={qrCodeUrl1} alt="QR Code 1" width="150" />
                  <div style={{ marginTop: "10px", fontWeight: "bold" }}>Search on the Block</div>
                </div>
              )}
              {qrCodeUrl2 && (
                <div>
                  <img src={qrCodeUrl2} alt="QR Code 2" width="150" />
                  <div style={{ marginTop: "10px", fontWeight: "bold" }}>Certificate's Picture</div>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {imagePreview && uploadedImage && (
        <div style={{ marginTop: "20px" }}>
          <h4>Preview of Uploaded Images:</h4>
          <img src={imagePreview} alt="Document Preview" width="300px" style={{ marginRight: "20px" }} />
          <img src={uploadedImage} alt="Verification Image" width="300px" />
          <button onClick={handleDownloadImagePDF} style={{ marginTop: "20px" }}>
            Download PDF with Image, Left QR Codes, and Watermark (100 credits)
          </button>
        </div>
      )}

      <br />
      <Link
        to={{
          pathname: "/pdfhash",
          state: {
            email: email,
            balance: balance
          }
        }}
      >
        &gt;&gt;&gt; Go To Step 2 - Please Hash Your Document
      </Link>
      <br />
      <div>Powered by</div>
      <img className="logo2" src={logo2} alt="Logo 2" />
      <div>New Wave Consulting Group</div>
    </div>
  );
};

export default ImageConverter;
